import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import NestedCheckbox from "components/common/nestedCheckbox/NestedCheckbox";
import Form from "react-bootstrap/Form";
import { useTranslation } from "react-i18next";
const ClaimsInfo = (props) => {
  const {
    permissions,
    handleChangeClaims,
    loading,
    formik,
    back,
    handleError,
    handleCompletion,
  } = props;
  const { t } = useTranslation();
  const STEP_ID = 3;
  useEffect(() => {
    handleError(STEP_ID, false);
    handleCompletion(STEP_ID, true);
  }, []);

  return (
    <div className="d-flex flex-column justify-content-between h-100">
      <div>
        <h6>{t("products")}</h6>
        <p>{t("users-access")}</p>
        <div className="claims">
          <NestedCheckbox
            formik={formik}
            permissionsList={permissions}
            component={"claims info"}
            handleChange={handleChangeClaims}
          />
        </div>
      </div>
      <hr className="horizentalLine" />

      <div>
        <h6>{t("user-status")}</h6>
        <div className="  d-flex">
          <div className="d-flex w-100 justify-content-between align-items-start">
            <p className="px-2">
              {formik.values.isActive ? t("active") : t("deactive")}
            </p>
            <Form.Check
              type="switch"
              id="custom-switch"
              className="checkbox-input px-2"
              aria-label="checkbox 1"
              name="isActive"
              checked={formik.values.isActive}
              onClick={formik.handleChange}
            />
          </div>
        </div>
        {/* {formik?.values?.roleId == "#EC" && (
          <p>{t("consultant-deactivate-warning-message")}</p>
        )} */}
      </div>
      <div className="d-flex justify-content-end align-items-center mt-5">
        <button
          className="parentbtn"
          style={{
            padding: "10px 35px",
            marginRight: "15px",
            backgroundColor: "gray",
          }}
          onClick={back}
        >
          {t("back")}
        </button>
        <button
          className="parentbtn"
          style={{
            padding: "10px 35px",
          }}
          type="submit"
        >
          {loading ? (
            <Spinner animation="border" size="sm" />
          ) : (
            t("update-user")
          )}
        </button>
      </div>
    </div>
  );
};

export default ClaimsInfo;
